export default __webpack_public_path__ + "static/media/mf.4b4f663e.svg";